import { render, staticRenderFns } from "./CompassSignatureNotice.vue?vue&type=template&id=d6c29b4a&scoped=true"
import script from "./CompassSignatureNotice.vue?vue&type=script&lang=js"
export * from "./CompassSignatureNotice.vue?vue&type=script&lang=js"
import style0 from "./CompassSignatureNotice.vue?vue&type=style&index=0&id=d6c29b4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c29b4a",
  null
  
)

export default component.exports